/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./AcInfoEdit.css";
import { renderErrorMsg } from "../../assets/component/renderErrorMsg.js";
import { validDonorInfo } from "../../assets/validators/donorInfo.js";
import { simpleFetch } from "../../restWrapper";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";

import "react-phone-number-input/style.css";
import PhoneInput, { formatPhoneNumberIntl } from "react-phone-number-input";
import flags from "react-phone-number-input/flags";

class AcInfoEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...{
        errMsgs: [],
        originUsername: this.props.location.state.donor.username,
        organizationName: this.props.location.state.organizationName,
      },
      ...this.props.location.state,
    };

    this.setDonorData = (e, name) => {
      let donor = this.state.donor;
      donor[name] = e;
      this.setState({
        donor: donor,
      });
    };

    this.onSubmitClick = () => {
          
      const itemsArray = [
        "firstName",
        "lastName",
        "phoneNumber",

        "flatAndFloorNumber",
        "building",
        "street",
        "town",
        "country",

        "ageGroup",
        "birthdayMonth",
        "birthdayDayInMonth",
        "donorOrganization",
        "educationLevel",
      ];
      const isValidInfo = validDonorInfo(this.state.donor, this.props.language);
      const organizationName = this.props.location.state.organizationName;
      if (isValidInfo.isValid) {
        //this.state.donor
        let donorObj = {};
        for (var i = 0; i < itemsArray.length; i++) {
          const item = this.state.donor[itemsArray[i]];
          if (item) {
            donorObj[itemsArray[i]] = item;
          }
        }
        if (this.state.originUsername !== this.state.donor.username) {
          donorObj.username = this.state.donor.username;
        }
        donorObj.language = this.props.language;
        simpleFetch("/donors", "PUT", donorObj).then((res) => {
          if (res.status === 200) {
            if (donorObj.username) {
              this.props.logout().finally((res) => {
                this.props.history.push({
                  pathname: "/UsernameConfirm",
                  confirm: true,
                  nextPage: "/SelectMission",
                });
              });
            } else
              this.props.history.push({
                pathname: "/AcInfo",
                state: {
                  ...this.state,
                  organizationName: organizationName,
                },
              });
          }
          this.setState({
            errMsgs: [res.body.message],
          });
        });
      } else {
        this.setState({
          errMsgs: isValidInfo.msgs,
        });
      }
    };
  }

  render() {
    if (this.state.loading) {
      return <this.props.RenderFullPageLoading />;
    }

    //  const color = this.state.color; // color.headerColor , color.buttonColor

    if (!this.props.location.state || !this.props.location.state.color) {
      return null;
    }

    const backgroundOverrideStyle = {
      background: "#" + this.props.location.state.color.headerColor,
    };

    const color = this.props.location.state.color;
    const organizationName = this.props.location.state.organizationName;

    /*
    const backgroundbuttonOverrideStyle = {
      background: '#' + this.props.location.state.color.buttonColor
    };
*/

    return (
      <div className="AcInfoEdit-view">
        <Helmet>
          <title>{organizationName}</title>
        </Helmet>
        <div className="AcInfoEdit-bg" style={backgroundOverrideStyle} />
        <div className="AcInfoEdit-container">
          <div className="AcInfoEdit-header">
            <Link
              to={{
                pathname: "/AcInfo",
                state: {
                  color: color,
                  organizationName: organizationName,
                },
              }}
            >
              <div className="AcInfoEdit-backContainer">
                <div className="AcInfoEdit-back">
                  <div className="AcInfoEdit-backBtn"></div>
                  <div className="AcInfoEdit-backText">
                    {this.props.languageObj.backBtn}
                  </div>
                </div>
              </div>
            </Link>

            <div className="AcInfoEdit-headingText">
              {this.props.languageObj.headingText}
            </div>

            <div
              onClick={this.onSubmitClick}
              className="AcInfoEdit-finishContainer"
            >
              <div className="AcInfoEdit-finish">
                {this.props.languageObj.doneBtn}
              </div>
            </div>
          </div>

          <div className="AcInfoEdit-main">
            <div className="AcInfoEdit-inputContainer">
              <div style={{ "padding-left": "50px" }}>
                {this.state.errMsgs.map((err) => renderErrorMsg(err))}
              </div>
              {orderOfItems.map((item) => (
                <RenderItem
                  key={item}
                  item={item}
                  value={this.state.donor[item]}
                  text={this.props.languageObj.inputContainer[item]}
                  setDonorData={this.setDonorData}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const RenderItem = (props) => {
  if (!props) return null;

  const _editItem = (e) => {
    props.setDonorData(e.target.value, props.item);
  };
  switch (props.item) {
    case "phoneNumber":
      return (
        <div className="AcInfoEdit-item">
          {props.text}
          <div className="AcInfoEdit-inputFieldContainer">
            <PhoneInput
              placeholder={props.text}
              value={props.value}
              defaultCountry={"HK"}
              flags={flags}
              className="AcInfoEdit-inputField"
              onChange={(phone) => {
                const no = formatPhoneNumberIntl(phone);
                props.setDonorData(no, props.item);
              }}
            />
          </div>
        </div>
      );
    default:
      return (
        <div className="AcInfoEdit-item">
          {props.text}
          <div className="AcInfoEdit-inputFieldContainer">
            <input
              type="text"
              placeholder={props.text}
              onChange={_editItem}
              className="AcInfoEdit-inputField"
              value={props.value}
            />
          </div>
        </div>
      );
  }
};

RenderItem.propTypes = {
  text: PropTypes.string,
  value: PropTypes.string,
  item: PropTypes.string,
  setDonorData: PropTypes.func,
};

const orderOfItems = [
  "username",
  "lastName",
  "firstName",
  //  "donorOrganization",
  "phoneNumber",
  //  "flatAndFloorNumber",
  //  "building",
  //  "street",
  //  "town",
  //  "country"
];

AcInfoEdit.propTypes = {
  language: PropTypes.string,
  languageObj: PropTypes.object,
  logout: PropTypes.func,
};

export default AcInfoEdit;
